import { HeroBlock } from "../../../types";
import HeroSection from "@/components/Landingpage/HeroSection";

interface HeroProps {
  block: HeroBlock;
}

export default function Hero({ block }: HeroProps) {
  const bgImage = block.image?.asset?.url;

  return (
    <div>
      {/* Mobile Image */}
      <div className="md:hidden pt-[2rem]">
        {bgImage && (
          <img
            src={bgImage}
            alt={block.image.alt || block.title}
            className="w-full object-cover"
          />
        )}
      </div>

      {/* Desktop Background & Content Wrapper */}
      <div className="relative flex justify-center">
        {/* Background Image Layer (Desktop Only) */}
        {bgImage && (
          <div
            className="absolute inset-0 hidden md:block bg-cover bg-center z-0"
            style={{ backgroundImage: `url(${bgImage})` }}
          />
        )}

        <div className="relative max-w-[95rem] md:rounded-none rounded-2xl md:translate-y-0 -translate-y-10 z-20 bg-white md:bg-transparent px-2 mx-auto w-full">
          <HeroSection title={block.title} subtitle={block.subtitle} />
        </div>

        {/* Gradient Overlay (Desktop) */}
        <div className="h-[30rem] hidden md:block w-full absolute bottom-0 left-0 bg-gradient-to-b from-transparent from-40% to-gray-800/70 z-0 pointer-events-none"></div>
      </div>
    </div>
  );
}
